<div class="container">
  <h1 class="page-title">
    <span class="icon"><i class="fas fa-bell"></i></span>{{ "BellNotifications.Header" | translate }}
  </h1>
  <p-card>
    <p-accordion>
      <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [(selected)]="isSearchFormOpen">
        <form [formGroup]="searchForm">
          <div class="grid formgrid p-fluid">
            <div class="field col-12">
              <label>{{ 'BellNotifications.Form.TitleOrContentText' | translate }}</label>
              <p-chips formControlName="textList" separator="," (onAdd)="chipsAdd($event, 'textList')"></p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 laas-calendar">
              <laas-calendar
                #notifyDt
                [title]="'BellNotifications.Form.NotifyDate'"
                [enableMaxDateIsToday]="true"
                [showRangeMode]="true"
                [showStartMode]="true"
                [defaultDate]="defaultNotifyDt"
                (onDateChange)="dateOnChange($event, 'notifyDt')">
              </laas-calendar>
            </div>

            <div class="field col-12">
              <small><strong class="p-invalid">
                {{ 'BellNotifications.Message.FileLimit' | translate }}
              </strong></small>
            </div>
          </div>
          <div>
            <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchBtnClick()">
            </button>
            <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" type="reset" (click)="resetBtnClick()"
                class="p-button-secondary ml-2"></button>
          </div>
        </form>
      </p-accordionTab>
      <div class="flex" style="margin-top: 10px;">
        <div style="display: flex; align-items: center;">
          <p-radioButton
            class="ml-2"
            name="showType"
            value="all"
            label="{{ 'Common.Button.All' | translate }}"
            [(ngModel)]="selectedShowType"
            (ngModelChange)="changeBellNotificationData(selectedShowType)">
          </p-radioButton>
          <p-radioButton
            class="ml-2"
            name="showType"
            value="unread"
            label="{{ 'Common.Button.Unread' | translate }}"
            [(ngModel)]="selectedShowType"
            (ngModelChange)="changeBellNotificationData(selectedShowType)">
          </p-radioButton>
        </div>
        <div style="display: flex; flex: 1; justify-content: flex-end;">
          <button
            pButton
            type="button"
            class="p-button-text"
            label="{{ 'BellNotifications.Button.MarkRead' | translate}}"
            (click)="markRead('SelectedRow')">
          </button>
          <button
            pButton
            type="button"
            class="p-button-text"
            label="{{ 'BellNotifications.Button.MarkReadAll' | translate}}"
            (click)="markRead('ALL')">
          </button>
        </div>
      </div>
    </p-accordion>
    <div class="mt-2">
      <laas-data-table
        #dataTable
        [dataKey]="'seqNo'"
        [tableKey]="preferenceKey"
        [value]="bellNotificationData"
        [defaultColumns]="bellNotificationColumns"
        [loading]="isLoading"
        [lazy]="true"
        [selectable]="true"
        (tableOnPage)="tablePageChange($event)"
        (tableOnSort)="tableSort($event)"
        (onRowClick)="onRowClick($event)">
        <ng-template pTemplate="caption">
          <button
            (click)="exportBtnClick($event)"
            pButton
            class="p-button-info ml-2"
            label="{{ 'Common.Button.Export' | translate }}"
          ></button>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'isRead'" class="p-fluid">
                {{ rowData[col.field] | optionsMapping: isReadStatusOptions | replaceNullWith: "-" }}
              </ng-container>
              <ng-container *ngSwitchDefault class="p-fluid">
                <ng-container [ngSwitch]="col.dataType">
                  <ng-container *ngSwitchCase="'date'" class="p-fluid">
                    <div class="overflow-text">
                      {{ rowData[col.field] | date : "yyyy-MM-dd HH:mm:ss" | replaceNullWith: "-" }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault class="p-fluid">
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith: "-" }}
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>
      </laas-data-table>
    </div>
  </p-card>
</div>
